<template>
  <div class="select">
    <div class="wrapper">
      <div class="container">

        <div class="left">
          <div class="content">
            <back-action />
            <h1>Wil je kennis opdoen of delen?</h1>
          </div>
        </div>

        <div class="right">
          <div class="content" id="main">
            <div class="inner">
              <div class="rows">


                <router-link to="/sport-mvb" class="col">
                  <div class="col__rows">
                    <div class="col__rows--left">
                      <h2 class="title">Ik wil meelopen en leren</h2>
                      <p class="sub">Je kijkt mee bij een organisatie in het buitenland en doet nieuwe kennis en vaardigheden op.</p>
                    </div>
                    <div class="col__rows--right">
                      <button class="button">Maak keuze</button>
                    </div>
                  </div>
                </router-link>

                <router-link to="/sport-mvb" class="col">
                  <div class="col__rows">
                    <div class="col__rows--left">
                      <h2 class="title">Ik wil training of coaching geven</h2>
                      <p class="sub">Je geeft training of coaching bij een organisatie in het buitenland en deelt je kennis en ervaring.</p>
                    </div>
                    <div class="col__rows--right">
                      <button class="button">Maak keuze</button>
                    </div>
                  </div>
                </router-link>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
